import { Button, Container, Group, Text, Title } from "@mantine/core";
import { ROUTE_DASHBOARD } from "constant/route";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { errorClasses } from "styles";

const Error503Page = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={errorClasses.root}>
      <Container>
        <Title className={errorClasses.title}>{t('error.503.title')}</Title>
        <Text size="lg" ta="center" className={errorClasses.description}>{t('error.503.description')}</Text>
        <Group justify="center">
          <Button variant={'filled'} size={'md'} onClick={() => navigate(ROUTE_DASHBOARD)}>{t('error.action')}</Button>
        </Group>
      </Container>
    </div>
  )
}

export default Error503Page;